import { PaginationResult } from "@covertree/types";

interface DataWithPagination {
  items: Array<unknown>;
  pagination: PaginationResult;
}

export const calculateTotalCount = (data?: DataWithPagination) => {
  return data?.pagination?.total ?? 0;
};
